<template>
  <div class="open-invoice-add open-invoice">
    <div class="open-invoice-flex">
      <div class="invoice-details">
        <div class="invoice-details-title">设置发票抬头</div>
        <div class="invoice-info">
          <div class="invoice-row">
            <div class="invoice-row-name"><span class="red">*</span>发票类型</div>
            <div class="invoice-row-flex">
              <div class="radio-label" v-for="(item,index) in invoiceTitleTypeList" :key="index" @click="form.invoiceTitleType = item.itemKey">
                <img src="../../assets/img/radio-y.png" alt="" v-if="form.invoiceTitleType == item.itemKey">
                <img src="../../assets/img/radio.png" alt="" v-else>
                {{item.itemValue}}
              </div>

            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name"><span class="red">*</span>抬头名称</div>
            <div class="invoice-row-flex">
              <input type="text" placeholder="请输入抬头名称" v-model="form.invoiceTitle">
            </div>
          </div>
            <div class="invoice-row">
              <div class="invoice-row-name"><span class="red" v-if="form.invoiceTitleType == 1">*</span>税号</div>
              <div class="invoice-row-flex">
                <input type="text" placeholder="请输入纳税人识别号" v-model="form.taxId">
              </div>
            </div>
            <div class="invoice-row">
              <div class="invoice-row-name"><span class="red" v-if="form.invoiceTitleType == 1">*</span>注册地址</div>
              <div class="invoice-row-flex">
                <input type="text" placeholder="请填写公司注册地址" v-model="form.registerAddress">
              </div>
            </div>
            <div class="invoice-row">
              <div class="invoice-row-name"><span class="red" v-if="form.invoiceTitleType == 1">*</span>注册电话</div>
              <div class="invoice-row-flex">
                <input type="text" placeholder="请填写公司注册电话" v-model="form.registerTelephone">
              </div>
            </div>
            <div class="invoice-row">
              <div class="invoice-row-name"><span class="red" v-if="form.invoiceTitleType == 1">*</span>开户银行</div>
              <div class="invoice-row-flex">
                <input type="text" placeholder="请填写公司开户银行" v-model="form.bankDeposit">
              </div>
            </div>
            <div class="invoice-row">
              <div class="invoice-row-name"><span class="red" v-if="form.invoiceTitleType == 1">*</span>银行账号</div>
              <div class="invoice-row-flex">
                <input type="text" placeholder="请填写公司银行账户" v-model="form.bankAccountNo">
              </div>
            </div>
        </div>
      </div>
      <div class="invoice-row row-box">
        <div class="invoice-row-flex">
          <div class="invoice-name">设为默认抬头</div>
          <div class="invoice-name-tips">每次开票会默认填写该抬头名称</div>
        </div>
        <div class="">
          <van-switch v-model="checked" active-color="#14CC80" size="26" />
        </div>
      </div>
    </div>
    <div class="btn-box">
      <pi-button type="primary" block @click="updateInvoiceTitle">保存</pi-button>
    </div>
  </div>
</template>
<script>
import { Switch } from 'vant';
import {updateInvoiceTitle, getDictInfoList,invoiceTitleDetails} from '../../common/api/index'
export default {
  name: 'pi-open-invoice-add',
  data(){
    return{
      checked:false,
      form: {
        "bankAccountNo": "",
        "bankDeposit": "",
        "hasDefault": 0,
        "invoiceTitle": "",
        "invoiceTitlePkId": "",
        "invoiceTitleType": 1,
        "registerAddress": "",
        "registerTelephone": "",
        "taxId": ""
      },
      invoiceTitleTypeList: [],
      invoiceTitleTypeObj: {}
    }
  },
  components: {
    [Switch.name]: Switch,
  },
  methods: {
    updateInvoiceTitle(){
      if(this.form.invoiceTitle == ''){
        this.$toast('请输入发票抬头');
        return;
      }else if(this.form.taxId == '' && this.form.invoiceTitleType == 1){
        this.$toast('请输入税号');
        return;
      }else if(this.form.invoiceTitleType == '1' && this.form.taxId.length< 6 || this.form.invoiceTitleType == '1' &&this.form.taxId.length > 20){
        this.$toast('请输入6~20位的税号');
        return;
      }else if(this.form.invoiceTitleType == '1' && this.form.registerAddress == ''){
        this.$toast('请输入注册地址','none');
        return;
      }else if(this.form.invoiceTitleType == '1' && this.form.registerTelephone == ''){
        this.$toast('请输入注册电话','none');
        return;
      }else if(this.form.invoiceTitleType == '1' && this.form.bankDeposit == ''){
        this.$toast('请输入开户银行','none');
        return;
      }else if(this.form.invoiceTitleType == '1' && this.form.bankAccountNo == ''){
        this.$toast('请输入银行账号','none');
        return;
      }

      this.form.hasDefault = this.checked ? 1 : 0; 
      updateInvoiceTitle(this.form).then(ret=>{
        if (ret.status == this.$config.ajaxStatus) {
          this.$toast('新增成功');
          this.$common.goBack();
        }else{
          this.$toast(ret.msg);
        }
      })
    },
    getDictInfoList(){
      getDictInfoList({
        typeIdList: '12414',
      }, true).then((data) => {
        if (data.status === this.$config.ajaxStatus) {
          
          if(data.data.length > 0){
            let invoiceTitleTypeList = [];
            let invoiceTitleTypeObj = {};

            data.data.map(item=>{
              if(item.typePkId == 12414){
                invoiceTitleTypeObj[item.itemKey] = item.itemValue;
                invoiceTitleTypeList.push(item);
              }
            })

            this.invoiceTitleTypeList = invoiceTitleTypeList;
            this.invoiceTitleTypeObj = invoiceTitleTypeObj;
          }
        }
      })
    },
    invoiceTitleDetails(invoiceTitlePkId){
      invoiceTitleDetails({invoiceTitlePkId: invoiceTitlePkId}).then(ret=>{
        if (ret.status === this.$config.ajaxStatus) {
          let data = ret.data[0];
          this.form.bankAccountNo = data.bankAccountNo;
          this.form.bankDeposit = data.bankDeposit;
          this.form.hasDefault = data.hasDefault;
          this.form.invoiceTitle = data.invoiceTitle;
          this.form.invoiceTitlePkId = data.invoiceTitlePkId;
          this.form.invoiceTitleType = data.invoiceTitleType;
          this.form.registerTelephone = data.registerTelephone;
          this.form.registerAddress = data.registerAddress;
          this.form.taxId = data.taxId;
          this.checked = this.form.hasDefault == 1 ? true : false; 
        }else{
          this.$toast(ret.msg);
        }
      })
    }
  },
  mounted() {
    let invoiceTitlePkId = this.$route.query.invoiceTitlePkId;
    if(invoiceTitlePkId){
      this.invoiceTitleDetails(invoiceTitlePkId);
    }
    if(this.$route.query.invoiceTitleType){
      this.form.invoiceTitleType = this.$route.query.invoiceTitleType;
    }
    this.$common.bodyAddBg();
    this.getDictInfoList();
  },
  destroyed () {
    this.$common.removeBodyBg();
  },
}
</script>
<style lang="less">
@import url('../open-invoice/css/invoice');
.open-invoice{
  
}
</style>